import { ENV } from '../../config/runtimeEnv';
import axios from 'axios';
import {
  BodyMapStatus,
  PatientBodyMap,
  PatientBodyMapStatus,
} from '../../types/healthcare/PatientAnalysisTypes';
import {
  BodyTagLinkedRecord,
  TagCategory,
  TagSeverity,
} from '../../types/healthcare/BodyAnalysisTypes';
import type { UserUuid } from '../../types/identity';
import { http } from '../../lib/http/client';

const BASE = ENV.VITE_HEALTHCARE_SERVER;

export interface BodyMapTagInput {
  region: string;
  category: TagCategory;
  severity: TagSeverity;
  title: string;
  detail: string;
  source?: string;
  linked_record?: BodyTagLinkedRecord;
}

export const fetchPatientBodyMap = async (
  patientId: UserUuid,
): Promise<PatientBodyMap | null> => {
  try {
    const res = await http.get(`${BASE}/patients/${patientId}/body-map`);
    return res.data.data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err) && err.response?.status === 404) return null;
    throw err;
  }
};

export const fetchPatientBodyMapStatus = async (
  patientId: UserUuid,
): Promise<PatientBodyMapStatus> => {
  const res = await http.get(`${BASE}/patients/${patientId}/body-map/status`);
  return res.data;
};

export const generatePatientBodyMap = async (
  patientId: UserUuid,
): Promise<{ message: string; status: BodyMapStatus }> => {
  const res = await http.post(
    `${BASE}/patients/${patientId}/body-map/generate`,
    {},
  );
  return res.data;
};

export const addBodyMapTag = async (
  patientId: UserUuid,
  payload: BodyMapTagInput,
): Promise<PatientBodyMap> => {
  const res = await http.post(
    `${BASE}/patients/${patientId}/body-map/tags`,
    payload,
  );
  return res.data.data;
};

export const updateBodyMapTag = async (
  patientId: UserUuid,
  tagId: string,
  payload: Partial<BodyMapTagInput>,
): Promise<PatientBodyMap> => {
  const res = await http.put(
    `${BASE}/patients/${patientId}/body-map/tags/${tagId}`,
    payload,
  );
  return res.data.data;
};

export const deleteBodyMapTag = async (
  patientId: UserUuid,
  tagId: string,
): Promise<PatientBodyMap> => {
  const res = await http.delete(`${BASE}/patients/${patientId}/body-map/tags/${tagId}`);
  return res.data.data;
};
